import { Injectable } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GoogleAdsAttributionService {

  private readonly GCLID_KEY = 'google_ads_gclid';
  private readonly GBRAID_KEY = 'google_ads_gbraid';
  private readonly WBRAID_KEY = 'google_ads_wbraid';

  constructor(private router: Router, private route: ActivatedRoute) { }

  /**
   * Initializes the attribution capture by listening to router events.
   * This should be called once in the AppComponent.
   */
  public initializeCapture(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.captureFromUrl();
    });
  }

  /**
   * Parses the current URL parameters and stores Google Ads click IDs in localStorage.
   */
  public captureFromUrl(): void {
    let currentRoute = this.route.root;
    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }

    const queryParams = currentRoute.snapshot.queryParams;

    if (queryParams['gclid']) {
      localStorage.setItem(this.GCLID_KEY, queryParams['gclid']);
    }
    if (queryParams['gbraid']) {
      localStorage.setItem(this.GBRAID_KEY, queryParams['gbraid']);
    }
    if (queryParams['wbraid']) {
      localStorage.setItem(this.WBRAID_KEY, queryParams['wbraid']);
    }
  }

  /**
   * Gets the stored GCLID.
   */
  public getGclid(): string | null {
    return localStorage.getItem(this.GCLID_KEY);
  }

  /**
   * Gets the stored GBRAID.
   */
  public getGbraid(): string | null {
    return localStorage.getItem(this.GBRAID_KEY);
  }

  /**
   * Gets the stored WBRAID.
   */
  public getWbraid(): string | null {
    return localStorage.getItem(this.WBRAID_KEY);
  }

  /**
   * Clears stored attribution data. Useful if you want to reset after a successful conversion.
   */
  public clearAttribution(): void {
    localStorage.removeItem(this.GCLID_KEY);
    localStorage.removeItem(this.GBRAID_KEY);
    localStorage.removeItem(this.WBRAID_KEY);
  }

  /**
   * Appends attribution data to a given payload object if they exist.
   * @param payload The object to append to.
   */
  public appendAttributionToPayload(payload: any): any {
    const gclid = this.getGclid();
    const gbraid = this.getGbraid();
    const wbraid = this.getWbraid();

    if (gclid) payload.gclid = gclid;
    if (gbraid) payload.gbraid = gbraid;
    if (wbraid) payload.wbraid = wbraid;
    
    return payload;
  }
}
